import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { GrupoProdutoRequest, Response } from './Types';

class GrupoProdutoController {
  public static async Listar(request: GrupoProdutoRequest): Promise<Response> {
    try {

      const response = await Api.post('api/grupoproduto/Listar', request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async ListarUnico(GrupoProdutoId: number): Promise<Response> {
    try {

      const response = await Api.get(
        `api/grupoproduto/ListarUnico/${GrupoProdutoId}`
      );

      const object = response?.data;

      const retorno: Response = {
        StatusCode: response.status,
        Data: object[0],
      };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Adicionar(
    request: GrupoProdutoRequest
  ): Promise<Response> {
    try {

      const response = await Api.post(`api/grupoproduto/Adicionar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: error?.response?.data.ErroDetalhado//ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Atualizar(
    request: GrupoProdutoRequest
  ): Promise<Response> {
    try {

      const response = await Api.put(`api/grupoproduto/Atualizar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Excluir(request: GrupoProdutoRequest): Promise<Response> {
    try {

      const response = await Api.put(`api/grupoproduto/Excluir`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }
}

export default GrupoProdutoController;
